import React, { useEffect, useRef } from 'react';

// TEMPORARILY DISABLED: AdSense keeps throwing "No slot size for
// availableWidth=0" in Chrome. Set to true to re-enable once the layout
// timing issue causing that is resolved.
const ADSENSE_ENABLED = false;

const AdSenseUnit = ({ 
  adSlot, 
  adFormat = 'auto',
  style = {}
}) => {
  const adRef = useRef(null);
  const isAdPushed = useRef(false);

  useEffect(() => {
    if (!ADSENSE_ENABLED) return;
    if (!adRef.current || isAdPushed.current) return;

    const el = adRef.current;
    let pollTimer = null;
    let cancelled = false;

    // adsbygoogle.push() doesn't measure/throw synchronously — it enqueues
    // the slot and Google's script processes it (and measures width) on a
    // later tick. A single width check right before push() isn't reliable
    // (Chrome renders real ads and can still catch the element mid-layout;
    // Brave never gets here since it blocks adsbygoogle.js outright). Poll
    // the ad element's actual rendered width until it's stable/non-zero,
    // and only push once confirmed — this is what avoids the
    // "No slot size for availableWidth=0" TagError.
    const tryPush = () => {
      if (cancelled || isAdPushed.current) return;
      const width = el.getBoundingClientRect().width;
      if (width > 0) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          isAdPushed.current = true;
        } catch (err) {
          console.error('AdSense error:', err);
        }
        return;
      }
      pollTimer = setTimeout(tryPush, 200);
    };

    // Delay initial attempt to after main UI renders
    const start = () => tryPush();
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 3000 });
    } else {
      setTimeout(start, 1500);
    }

    return () => {
      cancelled = true;
      if (pollTimer) clearTimeout(pollTimer);
    };
  }, []);

  if (!ADSENSE_ENABLED) return null;

  return (
    <div style={{ margin: '20px 0', textAlign: 'center', overflow: 'hidden', maxWidth: '100%', width: '100%', ...style }}>
      <ins 
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', width: '100%' }}
        data-ad-client="ca-pub-3800852593440607"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseUnit;
